export const XS_CHART_WIDTH = 750;
export const SM_CHART_WIDTH = 914;
export const MD_CHART_WIDTH = 1050;
export const LG_CHART_WIDTH = 1204;

export const FULL_CHART_HEIGHT = 500;
export const REDUCED_CHART_HEIGHT = 300;

export const TOOLTIP_CATEGORY_HEADER = "font-semibold indent-5";
export const TOOLTIP_INDENT = "indent-5";
export const TOOLTIP_SEMIBOLD = "font-semibold";
